import { makeStyles } from '@material-ui/core'
import { Theme } from '@styles/theme/theme'
import React from 'react'

export interface SVGExternalLinkIconProps {
  width?: string;
  height?: string;
  color?: string;
  hoverColor?: string;
  onClick?: () => void;
}
interface StyleProps {
  hoverColor?: string;
}
export const useStyles = makeStyles<Theme, StyleProps>(() => ({
  icon: {
    '&:hover path': {
      fill: (props: StyleProps) => props.hoverColor
    }
  },
}))

const SVGExternalLinkIcon = ({
  width = '32',
  height = '32',
  color = '#000',
  hoverColor = '#000',
  onClick,
}: SVGExternalLinkIconProps) => {
  const classes = useStyles({ hoverColor })
  return (
    <svg
      className={classes.icon}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M15 11C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9V11ZM23 17C23 16.4477 22.5523 16 22 16C21.4477 16 21 16.4477 21 17H23ZM15.2929 15.2929C14.9024 15.6834 14.9024 16.3166 15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071L15.2929 15.2929ZM23 9H24C24 8.44772 23.5523 8 23 8V9ZM22 13C22 13.5523 22.4477 14 23 14C23.5523 14 24 13.5523 24 13H22ZM19 8C18.4477 8 18 8.44772 18 9C18 9.55228 18.4477 10 19 10V8ZM20 21H12V23H20V21ZM11 20V12H9V20H11ZM12 11H15V9H12V11ZM21 17V20H23V17H21ZM12 21C11.4477 21 11 20.5523 11 20H9C9 21.6569 10.3431 23 12 23V21ZM20 23C21.6569 23 23 21.6569 23 20H21C21 20.5523 20.5523 21 20 21V23ZM11 12C11 11.4477 11.4477 11 12 11V9C10.3431 9 9 10.3431 9 12H11ZM16.7071 16.7071L23.7071 9.70711L22.2929 8.29289L15.2929 15.2929L16.7071 16.7071ZM22 9V13H24V9H22ZM23 8H19V10H23V8Z"
        fill={color}
      />
    </svg>
  )
}

export default SVGExternalLinkIcon
